/* Component Dependencies */
var heroTextOverlayTemplate = require('templates/heroTextOverlay.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');
var $ = require('jquery');

AriesComponent.create({
  type: 'heroTextOverlay',
  template: {
    'heroTextOverlay': heroTextOverlayTemplate
  },
  events: {
    'click .js-more-link': 'scrollToNextTile',
    'click .m-playPause-button,.vjs-big-play-button': 'pauseVideo'
  },
  bindEvents: function($) {
    var _self = this,
        $carousel,
        $buttonContainer,
        timer,
        delay = 800;
    _self.parentSelector = $('[data-component-id="' + _self.componentId + '"]');
    _self.registerPopup();
    $carousel = _self.parentSelector.find('.mi-carousel');
    $buttonContainer = _self.$el.find('.l-button-container');
    $playPauseButtonContainer =  _self.$el.find('.m-playPause-button-container');
    $playPauseButton =  _self.$el.find('.m-playPause-button-container .m-playPause-button');
    $carousel.on('afterChange', function(event, slick, currentSlide) {
      // load next and previous images
      var  $self = $(this),
        $nextSlide, $previousSlide,
        $currentSlide = slick.$slides.eq(currentSlide),
        $currentSlideImg = $currentSlide.find('img'),
        $prevPreviewImageContainer = $self.find(".slick-arrow.slick-prev .l-preview-image"),
        $nextPreviewImageContainer = $self.find(".slick-arrow.slick-next .l-preview-image"),
        $previousVideoIconContainer = $self.find(".slick-arrow.slick-prev .l-previousPlayButton-video"),
        $nextVideoIconContainer = $self.find(".slick-arrow.slick-next .l-nextPlayButton-video");
      if ((currentSlide + 1) < slick.$slides.length) {
        $nextSlide = slick.$slides.eq(currentSlide + 1);
        $previousSlide = slick.$slides.eq(currentSlide - 1);
      } else {
        // reset slide traversing
        $nextSlide = slick.$slides.eq(0);
        $previousSlide = slick.$slides.eq(currentSlide - 1);
      }
      if($currentSlide.data("autoplay") && $currentSlide.hasClass('l-video-wrapper') && $currentSlide.find('video').get(0).paused) {
        $currentSlide.find('video').get(0).play();
      }
      if($prevPreviewImageContainer && $($previousSlide[0]).data("preview") && !$previousSlide.hasClass('l-video-wrapper')) {
        $previousVideoIconContainer.removeClass('t-play-button-white l-preview-play-button');
        $prevPreviewImageContainer.removeAttr('style').css({
          'background-image': 'url(' + $($previousSlide[0]).data("preview") + ')',
          'transform': 'rotate(180deg)'
        });
      }else if ($prevPreviewImageContainer && $previousSlide.hasClass('l-video-wrapper')) {
        $previousVideoIconContainer.addClass('t-play-button-white l-preview-play-button');
        $prevPreviewImageContainer.removeAttr('style').css({
          'background-image': 'url(' + $($previousSlide[0]).data("preview") + ')',
          'transform': 'rotate(180deg)'
        });
      }
      if($nextPreviewImageContainer && $($nextSlide[0]).data("preview") && !$nextSlide.hasClass('l-video-wrapper')) {
        $nextVideoIconContainer.removeClass('t-play-button-white l-preview-play-button');
        $nextPreviewImageContainer.removeAttr('style').css({
          'background-image': 'url(' + $($nextSlide[0]).data("preview") + ')'
        });
      }else if ($nextPreviewImageContainer && $nextSlide.hasClass('l-video-wrapper')) {
        $nextVideoIconContainer.addClass('t-play-button-white l-preview-play-button');
        $nextPreviewImageContainer.removeAttr('style').css({
          'background-image': 'url(' + $($nextSlide[0]).data("preview") + ')'
        });
      }
    });

    $carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var $currentSlide, $nextSlide;
      if (currentSlide !== nextSlide) {
        $currentSlide = slick.$slides.eq(currentSlide);
        $nextSlide = slick.$slides.eq(nextSlide);
        if ($currentSlide.hasClass('l-video-wrapper') && !$currentSlide.find('video').get(0).paused) {
          $currentSlide.find('video').get(0).pause();
        }
        if ($nextSlide.hasClass('video-slide')) {
          $nextSlide.find('iframe').attr('src',  $nextSlide.data('videoLinkUrl'));
        }
      }
    });
    $carousel.on('init', function(event, slick) {
      var $self = $(this),
        currentSlideIndex, $currentSlide, $nextSlide, $previousSlide;
      $carousel.addClass('mi-prevent-reinit');
      currentSlideIndex = ($self.data('mediaid') - 1) || slick.slickCurrentSlide();
      $currentSlide = slick.$slides.eq(currentSlideIndex);
      
      if ((currentSlideIndex + 1) < slick.$slides.length) {
        $nextSlide  = slick.$slides.eq(currentSlideIndex + 1);
        $previousSlide = slick.$slides.eq(currentSlideIndex - 1);
      } else {
      // reset slide traversing
        $nextSlide = slick.$slides.eq(0);
        $previousSlide = slick.$slides.eq(currentSlide - 1);
      }
      if($currentSlide.data("autoplay") && $currentSlide.hasClass('l-video-wrapper') && $currentSlide.hasClass('slick-current') && $currentSlide.find('video').get(0).paused) {
        var $videoPlayer = $currentSlide.find('video');
        $videoPlayer.on('canplay',function() {
          $videoPlayer.get(0).play();
        })
      }
    });

    $carousel.find('video').on('play',function() {
      $buttonContainer.hide();
    });
    $carousel.find('video').on('pause',function() {
      $buttonContainer.show();
    });
    // Code for fadein fadeout play and pause button on click
    $carousel.find('video').on('click',function() {
      if($('.vjs-has-started').hasClass('vjs-playing')){
        $playPauseButtonContainer.css('z-index',1);
        $playPauseButtonContainer.addClass('background-showHide');
        $playPauseButton.removeClass('button-pause');
        $playPauseButton.addClass('button-play');
        timer = setTimeout(function() {
          $playPauseButton.removeClass('button-play');
          $playPauseButtonContainer.css('z-index',-1);
          $playPauseButtonContainer.removeClass('background-showHide');
        }, delay);
      }
      if($('.vjs-has-started').hasClass('vjs-paused')){
        $playPauseButtonContainer.css('z-index',1);
        $playPauseButtonContainer.addClass('background-showHide');
        $playPauseButton.removeClass('button-play');
        $playPauseButton.addClass('button-pause');
        timer = setTimeout(function() { 
          $playPauseButton.removeClass('button-pause');
          $playPauseButtonContainer.css('z-index',-1);
          $playPauseButtonContainer.removeClass('background-showHide');
          }, delay);
      }
    });
    // end code for fadein fadeout play and pause button on click
    /* prevent videojs default styles */
    window.VIDEOJS_NO_DYNAMIC_STYLE = true;
    /* ensure videojs plugin is attached to video element when the content is loaded in a overlay*/
    $(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-video');
  },
  /**
   * Register popup to show media viewer modal
   * @return {void}
   */
  registerPopup: function() {
    var _self = this;
    _self.mediaViewerPopup = new Popup({
      selector: '.tile-hero-carousel .js-media-viewer-trigger',
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true,
      fullScreen: true,
      mainClass: 'mi-gallery mi-gallery-full'
    });
    _self.mediaViewerPopup.register();
  },
  /**
   * scroll to next tile
   * @return {Void}
   */
  scrollToNextTile: function() {
    var _self = this,
        nextTileTop,
        $subSections = $('.mi-sub-section').not('.mi-sub-section-blank'),
        currTileSection = _self.$el.find(".l-more-link").parent().closest(".mi-sub-section");
    nextTileTop = $subSections && $subSections[$subSections.index(currTileSection)+1];
    if($(nextTileTop).offset()) {
      $('html, body').animate({
        scrollTop: $(nextTileTop).offset().top- $('html').offset().top
      },'500');
    }
  },
  /**
   * this funtion is used to pause the video
   * @return {Void}
   */
  pauseVideo: function(e) {
    var $this = $(e.currentTarget);
    if($this.siblings('video').parent('.mi-video').hasClass('vjs-playing')) {
      $this.siblings('video').get(0).pause();
    }
  }
});
